import { I18N } from "oc-I18N";
import { ChevronLeftSvg } from "../../inlinesvgs/ChevronLeftSvg";
import { ChevronRightSvg } from "../../inlinesvgs/ChevronRightSvg";

const leftTitle = I18N("Element links selektieren");
const rightTitle = I18N("Element rechts selektieren");

export function LeftRightButtons() {
  const isActive = APP.arrangement.selectedObjects?.length;
  return (
    <div
      className="flex-row left-right-buttons"
      role="group"
      aria-label={I18N("aria::Element-Auswahlnavigation")}
    >
      <button
        className={`svg-button-dotted ${isActive ? "active" : ""}`}
        title={leftTitle}
        aria-label={leftTitle}
        data-button-key={leftTitle}
        onClick={() => {
          APP.arrangement.moveZaunelementSelection(-1);
          APP.logUserAction({ action: "moveZaunelementSelectionToLeft" });
        }}
      >
        <ChevronLeftSvg />
      </button>
      <button
        className={`svg-button-dotted ${isActive ? "active" : ""}`}
        title={rightTitle}
        aria-label={rightTitle}
        data-button-key={rightTitle}
        onClick={() => {
          APP.arrangement.moveZaunelementSelection(+1);
          APP.logUserAction({ action: "moveZaunelementSelectionToRight" });
        }}
      >
        <ChevronRightSvg />
      </button>
    </div>
  );
}
